 import React from "react";
import { useNavigate } from "react-router-dom";

function ProductCard({ item }) {
  const navigate = useNavigate();

 

  // 🔥 Smart Helper: Distance ya City dikhane ke liye
  // 🔥 Smart Helper: Distance ya City dikhane ke liye
  const getLocationText = () => {
    // Priority 1: Agar Distance hai (backend se calculated text aa raha hai jaise "2.5 km dur")
    if (item.distance) {
      return item.distance; // 🔥 Koyi Math nahi! Seedha print karo.
    }
    
    // Priority 2: Agar Distance nahi hai, to City dikhao 
    // (Check karo ki city 'location' object me hai ya bahar)
    if (item.location?.city || item.city) {
      return item.location?.city || item.city;
    }

    // Priority 3: Kuch nahi hai
    return "N/A";
  };

  const locationLabel = getLocationText();

  return (
    <div 
      className="card shadow-sm h-100 border-0 mx-auto" 
      style={{ 
        width: "100%", 
        maxWidth: "280px", // 🔥 SAME WIDTH AS MYITEMCARD (Compact)
        cursor: "pointer", 
        overflow: "hidden",
        transition: "transform 0.2s"
      }}
      onClick={() => navigate(`/items/${item._id}`)}
      onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.02)"}
      onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
    >
      
      {/* IMAGE SECTION */}
      <div style={{ height: "160px", position: "relative", backgroundColor: "#fff" }}>
        <img 
          src={item.images?.[0]?.url || "https://via.placeholder.com/300"} 
          className="w-100 h-100" 
          style={{ objectFit: "contain", padding: "8px" }} 
          alt={item.title} 
        />
        
        {/* 🔥 LOCATION BADGE (Ab ye Distance ya City dono dikhayega) */}
        {locationLabel !== "N/A" && (
            <span className="position-absolute bottom-0 start-0 m-1 badge bg-dark bg-opacity-75" style={{fontSize: "10px", backdropFilter: "blur(2px)"}}>
               📍 {locationLabel}
            </span>
        )}
      </div>

      {/* DETAILS SECTION */}
      <div className="card-body p-2 d-flex flex-column">
        
        {/* Title */}
        <h6 className="fw-bold text-dark text-truncate mb-1" style={{ fontSize: "14px" }}>
            {item.title}
        </h6>
        
        {/* Category Badge */}
        <div className="mb-2">
            <span className="badge bg-light border text-secondary" style={{fontSize: "10px"}}>
                {item.category || "General"}
            </span>
        </div>

        {/* Price & Rent Button */}
        <div className="mt-auto d-flex align-items-center justify-content-between border-top pt-2">
            <div>
                <span className="fw-bold text-success" style={{fontSize: "14px"}}>₹{item.pricePerDay}</span>
                <span className="text-muted small" style={{fontSize: "10px"}}>/day</span>
            </div>
            
            {/* Rent Button */}
            <button className="btn btn-primary btn-sm fw-bold py-0 px-3" style={{fontSize: "12px", borderRadius: "20px"}}>
                Rent
            </button>
        </div>

      </div>
    </div>
  );
}

export default ProductCard;